/* Wishlist — Verobio v1.9.4
 * localStorage-based wishlist with drawer UI
 * v1.9.4: adiciona scroll explícito do container de itens no open() para garantir visibilidade
 * v1.9.3: fix deslocamento horizontal (guard + overflow-x hidden + padding-right + preventScroll)
 */
(function () {
  if (window.__wishlistInit) return;
  window.__wishlistInit = true;

  var STORAGE_KEY = 'verobio_wishlist';
  var productCache = {};
  var FETCH_TIMEOUT = 10000;
  var _qtyBusy = {};

  /* ── Fetch with timeout ────────────────────────────── */
  function fetchWithTimeout(url, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);
    var opts = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, opts).then(function (r) {
      clearTimeout(timer);
      return r;
    }).catch(function (err) {
      clearTimeout(timer);
      if (err.name === 'AbortError') {
        throw new Error('Tempo esgotado');
      }
      throw err;
    });
  }

  /* ── Server sync (fire and forget) ───────────────── */
  function syncToServer(action, type, handle) {
    var configEl = document.getElementById('server-sync-config');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config.customer_id) return;
    fetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shop: config.shop,
        customer_id: config.customer_id,
        action: action,
        type: type,
        handle: handle
      })
    }).catch(function () {});
  }

  /* ── Helpers ──────────────────────────────────────── */
  function getQtySelectorHtml(variantId, qty) {
    return '<div class="wishlist-drawer__qty" data-variant-id="' + variantId + '">'
      + '<button type="button" class="wishlist-drawer__qty-btn wishlist-drawer__qty-minus" aria-label="Diminuir">&minus;</button>'
      + '<span class="wishlist-drawer__qty-value">' + qty + '</span>'
      + '<button type="button" class="wishlist-drawer__qty-btn wishlist-drawer__qty-plus" aria-label="Aumentar">+</button>'
      + '<span class="wishlist-drawer__qty-label">' + qty + ' no carrinho</span>'
      + '</div>';
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Se cart vazio mas badge mostra >0, sessao expirou — nao zerar */
        var cartBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (cart.item_count === 0 && cartBubble && parseInt(cartBubble.textContent, 10) > 0) return;
        if (cartBubble) cartBubble.textContent = cart.item_count;
        var cartBubbleContainer = document.querySelector('.cart-count-bubble');
        if (cartBubbleContainer && cart.item_count > 0) cartBubbleContainer.style.display = '';
      });
  }

  function toggleViewCartLink() {
    var container = document.getElementById('WishlistDrawerItems');
    if (!container) return;
    var hasQty = container.querySelector('.wishlist-drawer__qty');
    var existing = container.querySelector('.wishlist-drawer__view-cart-wrap');
    if (hasQty && !existing) {
      var wrap = document.createElement('div');
      wrap.className = 'wishlist-drawer__view-cart-wrap';
      wrap.innerHTML = '<a href="/cart" class="wishlist-drawer__view-cart">Ver carrinho</a>';
      container.appendChild(wrap);
    } else if (!hasQty && existing) {
      existing.remove();
    }
  }

  function flashQtyError(qtyDiv) {
    if (!qtyDiv) return;
    qtyDiv.style.outline = "2px solid rgba(200,0,0,0.45)";
    qtyDiv.style.outlineOffset = "2px";
    qtyDiv.style.borderRadius = "4px";
    setTimeout(function () {
      qtyDiv.style.outline = "";
      qtyDiv.style.outlineOffset = "";
      qtyDiv.style.borderRadius = "";
    }, 1500);
  }

  function toggleAddAllButton() {
    var footer = document.getElementById('WishlistDrawerFooter');
    if (!footer) return;
    var container = document.getElementById('WishlistDrawerItems');
    if (!container) return;
    var hasAtcButtons = container.querySelector('.wishlist-drawer__add-to-cart');
    footer.style.display = hasAtcButtons ? '' : 'none';
  }

  /* ── WishlistStore ─────────────────────────────────── */
  var WishlistStore = {
    getItems: function () {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        return [];
      }
    },

    setItems: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.wishlistUpdate, { items: items });
      }
    },

    addItem: function (handle) {
      var items = this.getItems();
      if (items.indexOf(handle) === -1) {
        items.push(handle);
        this.setItems(items);
        syncToServer('add', 'wl', handle);
      }
    },

    removeItem: function (handle) {
      var items = this.getItems().filter(function (h) { return h !== handle; });
      this.setItems(items);
      syncToServer('remove', 'wl', handle);
    },

    hasItem: function (handle) {
      return this.getItems().indexOf(handle) !== -1;
    },

    toggle: function (handle) {
      if (this.hasItem(handle)) {
        this.removeItem(handle);
        return false;
      }
      this.addItem(handle);
      return true;
    },

    getCount: function () {
      return this.getItems().length;
    },

    markAll: function () {
      var self = this;
      document.querySelectorAll('.bitbpo-wishlist-toggle').forEach(function (el) {
        var handle = el.getAttribute('data-product-handle');
        if (self.hasItem(handle)) {
          el.classList.add('is-wishlisted');
          el.setAttribute('aria-pressed', 'true');
        } else {
          el.classList.remove('is-wishlisted');
          el.setAttribute('aria-pressed', 'false');
        }
      });
    },

    updateBadge: function () {
      var count = this.getCount();
      var bubble = document.querySelector('.wishlist-count-bubble');
      if (!bubble) return;
      var span = bubble.querySelector('span');
      if (count > 0) {
        bubble.style.display = '';
        if (span) span.textContent = count;
      } else {
        bubble.style.display = 'none';
        if (span) span.textContent = '0';
      }
    },

    fetchProduct: function (handle) {
      if (productCache[handle]) {
        return Promise.resolve(productCache[handle]);
      }
      return fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Product not found');
          return r.json();
        })
        .then(function (product) {
          productCache[handle] = product;
          return product;
        });
    },

    fetchAllProducts: function () {
      var handles = this.getItems();
      return Promise.all(handles.map(function (h) {
        return WishlistStore.fetchProduct(h).catch(function () { return null; });
      })).then(function (products) {
        return products.filter(function (p) { return p !== null; });
      });
    }
  };

  window.WishlistStore = WishlistStore;

  /* ── Event delegation ──────────────────────────────── */
  document.addEventListener('click', function (e) {
    /* Toggle wishlist on product card */
    var toggleBtn = e.target.closest('.bitbpo-wishlist-toggle');
    if (toggleBtn) {
      e.preventDefault();
      var handle = toggleBtn.getAttribute('data-product-handle');
      if (handle) {
        WishlistStore.toggle(handle);
        WishlistStore.markAll();
        WishlistStore.updateBadge();
      }
      return;
    }

    /* Add to cart from drawer */
    var atcBtn = e.target.closest('.wishlist-drawer__add-to-cart');
    if (atcBtn) {
      e.preventDefault();
      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adicionando...';

      fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (r.status === 401) throw new Error('session');
          if (!r.ok) {
            return r.json().then(function (data) {
              throw new Error(data.description || data.message || 'Erro');
            }).catch(function (parseErr) {
              if (parseErr.message === 'session') throw parseErr;
              if (parseErr.message && parseErr.message !== 'Erro') throw parseErr;
              throw new Error('Erro');
            });
          }
          return r.json();
        })
        .then(function () {
          var tmp = document.createElement('div');
          tmp.innerHTML = getQtySelectorHtml(variantId, 1);
          atcBtn.replaceWith(tmp.firstChild);
          document.dispatchEvent(new CustomEvent('cart:item-added'));
          refreshCartBadge();
          toggleViewCartLink();
          toggleAddAllButton();
        })
        .catch(function (err) {
          if (err.message === 'session') {
            atcBtn.textContent = 'Sessão expirada';
            atcBtn.disabled = false;
            setTimeout(function () { window.location.reload(); }, 1500);
          } else {
            atcBtn.textContent = err.message || 'Erro - tente novamente';
            atcBtn.disabled = false;
            setTimeout(function () { atcBtn.textContent = 'Adicionar ao carrinho'; }, 3000);
          }
        });
      return;
    }

    /* Remove from drawer */
    var removeBtn = e.target.closest('.wishlist-drawer__remove');
    if (removeBtn) {
      e.preventDefault();
      var removeHandle = removeBtn.getAttribute('data-product-handle');
      if (removeHandle) {
        WishlistStore.removeItem(removeHandle);
        WishlistStore.markAll();
        WishlistStore.updateBadge();
        var itemEl = removeBtn.closest('.wishlist-drawer__item');
        if (itemEl) itemEl.remove();
        /* Show empty message if no items left */
        var itemsContainer = document.getElementById('WishlistDrawerItems');
        if (itemsContainer && !itemsContainer.querySelector('.wishlist-drawer__item')) {
          var drawerEl = document.querySelector('wishlist-drawer');
          if (drawerEl && drawerEl.getEmptyHtml) {
            itemsContainer.innerHTML = drawerEl.getEmptyHtml();
          } else {
            itemsContainer.innerHTML = '<p class="wishlist-drawer__empty">Nenhum favorito adicionado.</p>';
          }
        }
      }
      return;
    }

    /* Qty plus in drawer */
    var qtyPlus = e.target.closest('.wishlist-drawer__qty-plus');
    if (qtyPlus) {
      e.preventDefault();
      var qtyDiv = qtyPlus.closest('.wishlist-drawer__qty');
      if (!qtyDiv) return;
      var vid = qtyDiv.getAttribute('data-variant-id');
      if (_qtyBusy[vid]) return;
      _qtyBusy[vid] = true;
      var valSpan = qtyDiv.querySelector('.wishlist-drawer__qty-value');
      var labelSpan = qtyDiv.querySelector('.wishlist-drawer__qty-label');
      var cur = parseInt(valSpan.textContent, 10);
      var nq = cur + 1;
      valSpan.textContent = nq;
      labelSpan.textContent = nq + ' no carrinho';
      fetchWithTimeout('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: nq })
      })
        .then(function (r) {
          if (r.status === 401) throw new Error('session');
          if (!r.ok) throw new Error('Erro');
          refreshCartBadge();
        })
        .catch(function (err) {
          if (err.message === 'session') {
            window.location.reload();
          } else {
            flashQtyError(qtyDiv);
          }
        })
        .finally(function () { _qtyBusy[vid] = false; });
      return;
    }

    /* Qty minus in drawer */
    var qtyMinus = e.target.closest('.wishlist-drawer__qty-minus');
    if (qtyMinus) {
      e.preventDefault();
      var qtyDiv2 = qtyMinus.closest('.wishlist-drawer__qty');
      if (!qtyDiv2) return;
      var vid2 = qtyDiv2.getAttribute('data-variant-id');
      if (_qtyBusy[vid2]) return;
      _qtyBusy[vid2] = true;
      var valSpan2 = qtyDiv2.querySelector('.wishlist-drawer__qty-value');
      var labelSpan2 = qtyDiv2.querySelector('.wishlist-drawer__qty-label');
      var cur2 = parseInt(valSpan2.textContent, 10);
      var nq2 = cur2 - 1;
      if (nq2 <= 0) {
        valSpan2.textContent = '…';
        labelSpan2.textContent = 'Removendo...';
        fetchWithTimeout('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid2, 10), quantity: 0 })
        })
          .then(function (r) {
            if (r.status === 401) throw new Error('session');
            if (!r.ok) throw new Error('Erro');
            var tmp2 = document.createElement('div');
            tmp2.innerHTML = '<button type="button" class="wishlist-drawer__add-to-cart button button--small" data-variant-id="' + vid2 + '">Adicionar ao carrinho</button>';
            qtyDiv2.replaceWith(tmp2.firstChild);
            refreshCartBadge();
            toggleViewCartLink();
            toggleAddAllButton();
          })
          .catch(function (err) {
            if (err.message === 'session') {
              window.location.reload();
            } else {
              valSpan2.textContent = cur2;
              labelSpan2.textContent = cur2 + ' no carrinho';
              flashQtyError(qtyDiv2);
            }
          })
          .finally(function () { _qtyBusy[vid2] = false; });
      } else {
        valSpan2.textContent = nq2;
        labelSpan2.textContent = nq2 + ' no carrinho';
        fetchWithTimeout('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid2, 10), quantity: nq2 })
        })
          .then(function (r) {
            if (r.status === 401) throw new Error('session');
            if (!r.ok) throw new Error('Erro');
            refreshCartBadge();
          })
          .catch(function (err) {
            if (err.message === 'session') {
              window.location.reload();
            } else {
              flashQtyError(qtyDiv2);
            }
          })
          .finally(function () { _qtyBusy[vid2] = false; });
      }
      return;
    }

    /* Add all to cart */
    var addAllBtn = e.target.closest('.wishlist-drawer__add-all');
    if (addAllBtn) {
      e.preventDefault();
      var allContainer = document.getElementById('WishlistDrawerItems');
      if (!allContainer) return;
      var buttons = allContainer.querySelectorAll('.wishlist-drawer__add-to-cart');
      var totalItems = allContainer.querySelectorAll('.wishlist-drawer__item').length;
      var skippedCount = totalItems - buttons.length;
      if (buttons.length === 0) return;
      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adicionando...';
      var itemsToAdd = [];
      buttons.forEach(function (btn) {
        var bvid = btn.getAttribute('data-variant-id');
        if (bvid) {
          itemsToAdd.push({ id: parseInt(bvid, 10), quantity: 1 });
          btn.disabled = true;
          btn.textContent = 'Adicionando...';
        }
      });
      fetchWithTimeout('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      })
        .then(function (r) {
          if (r.status === 401) throw new Error('session');
          if (!r.ok) {
            return r.json().then(function (data) {
              throw new Error(data.description || data.message || 'Erro');
            }).catch(function (parseErr) {
              if (parseErr.message === 'session') throw parseErr;
              if (parseErr.message && parseErr.message !== 'Erro') throw parseErr;
              throw new Error('Erro');
            });
          }
          return r.json();
        })
        .then(function () {
          buttons.forEach(function (btn) {
            var bvid = btn.getAttribute('data-variant-id');
            var tmp3 = document.createElement('div');
            tmp3.innerHTML = getQtySelectorHtml(bvid, 1);
            btn.replaceWith(tmp3.firstChild);
          });
          document.dispatchEvent(new CustomEvent('cart:item-added'));
          refreshCartBadge();
          toggleViewCartLink();
          toggleAddAllButton();
          if (skippedCount > 0) {
            var added = buttons.length;
            addAllBtn.textContent = added + ' de ' + totalItems + ' adicionados';
            setTimeout(function () { addAllBtn.textContent = 'Adicionar todos ao carrinho'; }, 4000);
          } else {
            addAllBtn.textContent = 'Adicionar todos ao carrinho';
          }
          addAllBtn.disabled = false;
        })
        .catch(function (err) {
          if (err.message === 'session') {
            addAllBtn.textContent = 'Sessão expirada';
            setTimeout(function () { window.location.reload(); }, 1500);
          } else {
            buttons.forEach(function (btn) {
              btn.textContent = 'Adicionar ao carrinho';
              btn.disabled = false;
            });
            addAllBtn.textContent = err.message || 'Erro - tente novamente';
            addAllBtn.disabled = false;
            setTimeout(function () { addAllBtn.textContent = 'Adicionar todos ao carrinho'; }, 3000);
          }
        });
      return;
    }

    /* Header icon opens drawer */
    var headerIcon = e.target.closest('#wishlist-icon-bubble');
    if (headerIcon) {
      e.preventDefault();
      var drawer = document.querySelector('wishlist-drawer');
      if (drawer && drawer.open) drawer.open();
      return;
    }
  });

  /* ── Custom element <wishlist-drawer> ──────────────── */
  if (typeof customElements !== 'undefined' && !customElements.get('wishlist-drawer')) {
    customElements.define('wishlist-drawer', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var closeBtn = this.querySelector('.wishlist-drawer__close');
        var overlay = this.querySelector('#WishlistDrawer-Overlay');

        if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
        if (overlay) overlay.addEventListener('click', function () { self.close(); });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.classList.contains('active')) {
            self.close();
          }
        });
      }

      open() {
        var self = this;
        if (self.classList.contains('active')) return;
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.style.display = 'none';
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollbarWidth > 0) document.body.style.paddingRight = scrollbarWidth + 'px';
        document.body.classList.add('overflow-hidden');
        document.documentElement.style.overflowX = 'hidden';
        self.classList.add('active');
        self.offsetHeight;
        self.classList.add('is-open');
        self.renderItems();
        var dialog = self.querySelector('.wishlist-drawer__panel');
        if (dialog) {
          dialog.focus({ preventScroll: true });
          // Scroll o container de itens para o topo para garantir visibilidade
          var itemsContainer = self.querySelector('.wishlist-drawer__items');
          if (itemsContainer) {
            itemsContainer.scrollTop = 0;
          }
        }
      }

      close() {
        var self = this;
        self.classList.remove('is-open');
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          self.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
          document.body.style.paddingRight = '';
          document.documentElement.style.overflowX = '';
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.style.display = '';
        };
        var panel = self.querySelector('.wishlist-drawer__panel');
        if (panel) {
          panel.addEventListener('transitionend', function onEnd() {
            panel.removeEventListener('transitionend', onEnd);
            finish();
          });
        }
        setTimeout(finish, 350);
      }

      getLoginBannerHtml() {
        var drawer = document.getElementById('WishlistDrawer');
        var loginUrl = drawer ? drawer.getAttribute('data-login-url') : null;
        if (loginUrl) {
          return '<div class="wishlist-drawer__login">'
            + '<p class="wishlist-drawer__login-title">Faça o login para salvar os seus favoritos</p>'
            + '<a href="' + loginUrl + '" class="wishlist-drawer__login-button">Entrar</a>'
            + '</div>';
        }
        return '';
      }

      getEmptyHtml() {
        var loginBanner = this.getLoginBannerHtml();
        if (loginBanner) return loginBanner;
        return '<p class="wishlist-drawer__empty">Nenhum favorito adicionado.</p>';
      }

      getGreetingHtml() {
        var drawer = document.getElementById('WishlistDrawer');
        var customerName = drawer ? drawer.getAttribute('data-customer-name') : null;
        if (customerName) {
          return '<p class="wishlist-drawer__greeting">Olá, ' + customerName + '! Esses são os seus favoritos da nossa loja.</p>';
        }
        return '';
      }

      renderItems() {
        var self = this;
        var container = document.getElementById('WishlistDrawerItems');
        if (!container) return;

        var items = WishlistStore.getItems();
        if (items.length === 0) {
          container.innerHTML = self.getEmptyHtml();
          toggleAddAllButton();
          return;
        }

        container.innerHTML = '<p class="wishlist-drawer__loading">Carregando favoritos...</p>';

        Promise.all([
          WishlistStore.fetchAllProducts(),
          fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; })
        ]).then(function (results) {
          var products = results[0];
          var cart = results[1];

          if (products.length === 0) {
            container.innerHTML = self.getEmptyHtml();
            toggleAddAllButton();
            return;
          }

          var cartMap = {};
          cart.items.forEach(function (ci) {
            cartMap[ci.variant_id] = ci.quantity;
          });

          var hasCartItems = false;
          var html = self.getLoginBannerHtml() + self.getGreetingHtml();
          products.forEach(function (product) {
            var imgSrc = product.featured_image ? product.featured_image.replace(/\.([^.]+)$/, '_80x80_crop_center.$1') : '';
            var price = (product.price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
            var firstAvailable = null;
            if (product.variants) {
              for (var vi = 0; vi < product.variants.length; vi++) {
                if (product.variants[vi].available) {
                  firstAvailable = product.variants[vi];
                  break;
                }
              }
            }
            var variantId = firstAvailable ? firstAvailable.id : '';
            var available = !!firstAvailable;
            var cartQty = variantId ? (cartMap[variantId] || 0) : 0;

            html += '<div class="wishlist-drawer__item" data-product-handle="' + product.handle + '">';
            html += '<a href="/products/' + product.handle + '" class="wishlist-drawer__image-link">';
            if (imgSrc) {
              html += '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="80" height="80" loading="lazy">';
            }
            html += '</a>';
            html += '<div class="wishlist-drawer__info">';
            html += '<a href="/products/' + product.handle + '" class="wishlist-drawer__title">' + product.title + '</a>';
            html += '<span class="wishlist-drawer__price">' + price + '</span>';
            html += '<div class="wishlist-drawer__actions">';
            if (available && variantId) {
              if (cartQty > 0) {
                html += getQtySelectorHtml(variantId, cartQty);
                hasCartItems = true;
              } else {
                html += '<button type="button" class="wishlist-drawer__add-to-cart button button--small" data-variant-id="' + variantId + '">Adicionar ao carrinho</button>';
              }
            } else {
              html += '<span class="wishlist-drawer__sold-out">Produto indisponível</span>';
            }
            html += '<button type="button" class="wishlist-drawer__remove" data-product-handle="' + product.handle + '" aria-label="Remover dos favoritos">';
            html += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
            html += '</button>';
            html += '</div>';
            html += '</div>';
            html += '</div>';
          });

          if (hasCartItems) {
            html += '<div class="wishlist-drawer__view-cart-wrap"><a href="/cart" class="wishlist-drawer__view-cart">Ver carrinho</a></div>';
          }

          container.innerHTML = html;
          toggleAddAllButton();
        });
      }
    });
  }

  /* ── Init ───────────────────────────────────────────── */
  function init() {
    WishlistStore.markAll();
    WishlistStore.updateBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
